import PurchaseListV2 from "./purchaseList";
import PurchaseDetailV2 from "./PurchaseDetail";

export const PurchaseList = () => {
  return <PurchaseListV2 />;
};

export const PurchaseDetail = () => {
  return <PurchaseDetailV2 />;
};
